module.exports = __webpack_public_path__ + "media/kauffman-newsletter-2.jpg";